"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserRegistration = exports.UserRegistrationProvider = exports.UserRegistrationContext = void 0;
const react_1 = __importStar(require("react"));
exports.UserRegistrationContext = (0, react_1.createContext)(undefined);
/**
 * Manage the state of the user registration process while stepping through the registration process.
 * @param children
 * @returns
 */
const UserRegistrationProvider = ({ children, registrationProps }) => {
    // NOTE: we prepopulate some user values into `initialUserData` when user gets a popup on Pro page (to finish abandoned Freemium Onboarding). There, we need BOTH `userId` and `email`, because `userId` is used in each step to update the user data, and `email` is used on "Interestes" step to update the "remainingSteps" value in "Subscriptions > FreemiumOnboardingRemainingStep" collection
    const initialUserData = registrationProps.userId
        ? { id: registrationProps.userId, email: registrationProps.email }
        : {}; //  registrationProps is never going to change
    const [userData, setUserData] = (0, react_1.useState)(initialUserData);
    const initialStep = registrationProps.userId ? 'basicInfo' : 'email';
    const [step, setStep] = (0, react_1.useState)(initialStep);
    const [appProps, setAppProps] = (0, react_1.useState)(registrationProps);
    // Memoize the context value to prevent unnecessary re-renders.
    // By only recomputing the context value when dependencies (userData, step) change,
    // we ensure that the same context value object is returned unless its dependencies change.
    // This optimization helps in avoiding unnecessary updates downstream in the component tree
    // that consumes this context value, leading to better performance.
    const contextValue = (0, react_1.useMemo)(() => {
        return {
            userData,
            setUserData,
            step,
            setStep,
            appProps,
            setAppProps,
        };
    }, [userData, step, appProps]);
    return react_1.default.createElement(exports.UserRegistrationContext.Provider, { value: contextValue }, children);
};
exports.UserRegistrationProvider = UserRegistrationProvider;
const useUserRegistration = () => {
    const context = (0, react_1.useContext)(exports.UserRegistrationContext);
    if (!context) {
        throw new Error('useUserRegistration must be used within a UserRegistrationProvider');
    }
    return context;
};
exports.useUserRegistration = useUserRegistration;
